module.exports = __webpack_public_path__ + "static/media/shake-square.764c6e15.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/shake-square.jpg
 ** module id = 686
 ** module chunks = 0
 **/